import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { AUDIT_TOKENS } from "../../theme/auditTokens";

export type EmptyReason = "noVehicles" | "noTrips" | "filtered" | "loading" | "loadError";

declare module "@mui/x-data-grid-pro" {
  interface NoRowsOverlayPropsOverrides {
    emptyReason?: EmptyReason;
  }
}

/** Explains why the table is empty instead of a bare "no rows". */
export function AuditNoRowsOverlay({ emptyReason = "noTrips" }: { emptyReason?: EmptyReason }) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        p: "48px 20px",
        textAlign: "center",
        color: AUDIT_TOKENS.muted,
        fontSize: 14,
        gap: 0.5,
      }}
    >
      <Box sx={{ fontWeight: 600, color: AUDIT_TOKENS.text }}>{t(`logbookAudit.empty.${emptyReason}.title`)}</Box>
      <Box>{t(`logbookAudit.empty.${emptyReason}.body`)}</Box>
    </Box>
  );
}
